import PropTypes from 'prop-types'


export default class Feature {

  static props = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    icon: PropTypes.string,
  }

}
